(function () {
    'use strict';

    function main() {
        var page = wo$('#tablet');
        if (!page.length) return;

        var tabletController = {
            init: function () {
                tabletController.initHistoryTracker();
                WhistleOut.getAds('Tablets');

                page.find('[data-gallery]').each(function () {
                    wo$(this).magnificPopup({
                        delegate: 'a[data-gallery-item]',
                        type: 'image',
                        zoom: {
                            enabled: true,
                            duration: 400
                        },
                        gallery: {
                            enabled: true
                        }
                    });
                });

                page.find('a[data-gallery-opener]').click(function () {
                    wo$(this).parents('[data-gallery]').find('a[data-gallery-item]').last().click();
                });

                page.find('#whistleout-review-article img')
                    .one('load', function () {
                        tabletController.fixArticleImage(wo$(this));
                    })
                    .each(function () {
                        if (this.complete) {
                            tabletController.fixArticleImage(wo$(this));
                        }
                    });

                page.find('#also-viewed').change(function () {
                    var tablet = wo$(this).val();
                    location.href = tablet;
                });
            },

            initHistoryTracker: function () {
                WhistleOut.initHistoryTracker(tabletController);
            },

            fixArticleImage: function ($image) {
                if ($image.width() === 700) {
                    $image.addClass('fullwidth-image');
                }
            }
        };

        tabletController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
